import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const base =
  "group inline-flex items-center justify-center gap-2 font-display font-600 text-sm md:text-base rounded-md px-6 py-3.5 transition-[transform,background-color,color,border-color] duration-300 will-change-transform focus:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 focus-visible:ring-offset-paper";

const variants = {
  primary: "bg-teal text-ink hover:bg-teal-bright hover:-translate-y-0.5 shadow-[0_10px_30px_-12px_rgba(0,212,170,0.6)]",
  dark: "bg-ink text-white hover:bg-ink-700 hover:-translate-y-0.5",
  amber: "bg-amber text-ink hover:brightness-105 hover:-translate-y-0.5",
  outline: "border border-ink/25 text-ink hover:border-ink hover:-translate-y-0.5",
  ghostLight: "border border-white/25 text-white hover:bg-white/10 hover:-translate-y-0.5",
};

export const CTAButton = ({
  to,
  href,
  children,
  variant = "primary",
  arrow = true,
  className = "",
  onClick,
  type,
  ...rest
}) => {
  const cls = `${base} ${variants[variant]} ${className}`;
  const label = typeof children === "string" ? children : undefined;
  const track = {
    "data-umami-event": "CTA Click",
    ...(label ? { "data-umami-event-label": label } : {}),
    ...(to || href ? { "data-umami-event-destination": to || href } : {}),
  };
  const inner = (
    <>
      <span>{children}</span>
      {arrow && (
        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      )}
    </>
  );
  if (to) {
    return (
      <Link to={to} className={cls} onClick={onClick} {...track} {...rest}>
        {inner}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} onClick={onClick} {...track} {...rest}>
        {inner}
      </a>
    );
  }
  return (
    <button type={type || "button"} className={cls} onClick={onClick} {...track} {...rest}>
      {inner}
    </button>
  );
};
